import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { AccordionProvider } from './AccordionContext';
import AccordionHeading from './AccordionHeading';
import AccordionContent from './AccordionContent';
import AccordionButton from './AccordionButton';

export interface AccordionProps {
  as?: React.ElementType | string;
  /**
   * Close the accordion when clicking outside
   */
  autoClose?: boolean;
  children?: ReactNode;
  className?: string;
  id?: string;
  initialExpanded?: string | string[];
  multiple?: boolean;
  bordered?: boolean;
}

/**
 * The Accordion Component based on [The USWDS Accordion component](https://designsystem.digital.gov/components/accordion/)
 */
const Accordion = ({
  as: Component = 'div',
  autoClose,
  bordered,
  children,
  className,
  id,
  initialExpanded,
  multiple,
}: AccordionProps): React.ReactElement => {
  const accordionClassNames = classNames(className, {
    'usa-accordion': true,
    'usa-accordion--bordered': bordered,
  });

  return (
    <AccordionProvider initialExpanded={initialExpanded} multiple={multiple} autoClose={autoClose}>
      <Component id={id} className={accordionClassNames}>
        {children}
      </Component>
    </AccordionProvider>
  );
};

Accordion.Heading = AccordionHeading;
Accordion.Button = AccordionButton;
Accordion.Content = AccordionContent;

export default Accordion;
